export default __webpack_public_path__ + "static/media/Muni2.b7cd329f.jpg";